import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { getAppraisalClauseTerms } from '@/utils/appraisalClause';
import { Contract } from '@/types/ContractType';

const Appraisal = ({ contract }: { contract: Contract }) => {
  const terms = getAppraisalClauseTerms(
    contract?.contingency?.appraisalContingency
  );
  return (
    <View style={styles.section}>
      <Text style={styles.title}>APPRAISAL CONTINGENCY</Text>

      {terms.contingent ? (
        <>
          <Text style={styles.text}>
            1. <Text style={styles.ClauseText}>{terms.statement}</Text>
          </Text>

          <Text style={styles.text}>
            2. The Appraisal report must be completed within{' '}
            <Text style={styles.ClauseText}>
              {contract?.contingency?.daysFromExecutionDate ?? 'N/A'}
            </Text>{' '}
            days of the executed date of this contract, not including the
            executed date of this contract.
          </Text>

          <Text style={styles.text}>
            3. If the Property does not appraise at or above{' '}
            {terms.requiredAmount}, Buyer may terminate this Contract by
            providing written notice to Seller within{' '}
            <Text style={styles.ClauseText}>
              {contract?.contingency?.daysForAppraisalNegotiation ?? 'N/A'}
            </Text>{' '}
            days after Buyer's receipt of the appraisal report, providing that
            the Appraisal Report is received within{' '}
            <Text style={styles.ClauseText}>
              {contract?.contingency?.daysFromExecutionDate ?? 'N/A'}
            </Text>{' '}
            days from the date of execution of this Contract.
          </Text>

          <View style={styles.list}>
            <Text style={styles.listItem}>
              a. If Buyer terminates this Contract under this provision within{' '}
              <Text style={styles.ClauseText}>
                {contract?.contingency?.daysForAppraisalNegotiation ?? 'N/A'}
              </Text>{' '}
              days after Buyer's receipt of the appraisal report, the earnest
              money shall be returned to Buyer.
            </Text>

            <Text style={styles.listItem}>
              b. If Buyer does not terminate this Contract under this provision
              within{' '}
              <Text style={styles.ClauseText}>
                {contract?.contingency?.daysForAppraisalNegotiation ?? 'N/A'}
              </Text>{' '}
              days after Buyer's receipt of the appraisal report, the Contract
              shall proceed to Closing.
            </Text>

            <Text style={styles.listItem}>
              c. If the Property appraises for less than {terms.requiredAmount},
              Buyer may terminate this Contract or negotiate Purchase Price by
              providing written notice to Seller within{' '}
              <Text style={styles.ClauseText}>
                {contract?.contingency?.daysForAppraisalNegotiation ?? 'N/A'}
              </Text>{' '}
              days after Buyer's receipt of the appraisal report.
            </Text>

            <View style={styles.subList}>
              <Text style={styles.listItem}>
                i. Seller has{' '}
                <Text style={styles.ClauseText}>
                  {contract?.contingency?.daysForAppraisalNegotiation ?? 'N/A'}
                </Text>{' '}
                days not including the date of receipt of written notice of new
                Purchase Price to counter offer or accept.
              </Text>

              <Text style={styles.listItem}>
                ii. Both parties, Buyer and Seller are to be provided with a
                copy of the completed Appraisal Report.
              </Text>

              <Text style={styles.listItem}>
                iii. If either party prepares a reconsideration of value with
                comparable properties, the appraisal contingency timeline for
                any new appraisal report with a reconsideration of value is
                extended until receipt of the new appraisal report with a
                reconsideration of value.
              </Text>

              <Text style={styles.listItem}>
                iv. Upon receipt of an updated appraisal report without
                sufficient Appraiser's Opinion of Value, after a reconsideration
                of value request, Buyer retains right to terminate the purchase
                contract according to the terms of the Appraisal Contingency and
                has{' '}
                <Text style={styles.ClauseText}>
                  {contract?.contingency?.daysForAppraisalNegotiation ?? 'N/A'}
                </Text>{' '}
                days upon receipt of the updated appraisal report to terminate
                the contract.
              </Text>

              <Text style={styles.listItem}>
                v. Upon receipt of an updated appraisal report with sufficient
                Appraiser's Opinion of Value at or above {terms.requiredAmount},
                after a reconsideration of value request, Buyer forgoes the
                right to terminate the purchase contract according to the terms
                of the Appraisal Contingency.
              </Text>
            </View>
          </View>
        </>
      ) : (
        <Text style={styles.text}>{terms.statement}</Text>
      )}
    </View>
  );
};

export default Appraisal;
